export var PaymentType;
(function (PaymentType) {
    PaymentType["BankTransfer"] = "BankTransfer";
    PaymentType["CreditCard"] = "CreditCard";
    PaymentType["WireTransfer"] = "WireTransfer";
    PaymentType["Other"] = "Other";
})(PaymentType || (PaymentType = {}));
export var CreditCardType;
(function (CreditCardType) {
    CreditCardType["Visa"] = "Visa";
    CreditCardType["MasterCard"] = "MasterCard";
    CreditCardType["AmericanExpress"] = "AmericanExpress";
    CreditCardType["Discover"] = "Discover";
    CreditCardType["Diners"] = "Diners";
    CreditCardType["JCB"] = "JCB";
    CreditCardType["UnionPay"] = "UnionPay";
})(CreditCardType || (CreditCardType = {}));
//# sourceMappingURL=index.js.map